<template>
  <section id="profile">
    <div class="rounded info-panel bg-white mb-4 p-6 pb-0">
      <div class="d-flex flex-wrap flex-sm-nowrap">
        <div class="flex-grow-1">
          <div class="d-flex justify-content-between align-items-start flex-wrap mb-1" v-if="getUser">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <div class="text-primary fs-2 me-1">
                  {{ getUser.surname }} {{ getUser.name }} {{ getUser.patronymic }}
                </div>
              </div>
              <div class="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                <span class="d-flex align-items-center text-gray-500 me-5">
                  <i class="ki-outline ki-profile-circle fs-4 me-1"></i> {{ roleName }}
                </span>
                <span class="d-flex align-items-center text-gray-500">
                  <i class="ki-outline ki-sms fs-4 me-1"></i> {{ getUser.email }}
                </span>
              </div>
            </div>
            <div @click="logout" class="btn btn-light-danger btn-xs px-10">Выйти</div>
          </div>
          <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-7 fw-bold">
            <li class="nav-item">
              <router-link :to="{name:'Profile'}" class="nav-link text-active-primary ms-0 me-5 py-3">Профиль</router-link>
            </li>
            <li v-if="roleGroupSale.includes(this.$user.role)" class="nav-item">
              <router-link :to="{name:'AVR'}" class="nav-link text-active-primary ms-0 me-5 py-3">АВР</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <router-view :key="$route.path"/>
  </section>
</template>
<script>
  import permissions from '@/helpers/permissions'

  export default {
    name: 'ProfileLayout',
    data () {
      return {

      }
    },
    computed: {
      getUser() {
        return this.$store.state.user
      },
      roleName() {
        return permissions.roleName(this.getUser.role)
      },
      roleGroupSale() {
        return permissions.groupSale()
      },
    },
    methods: {
      logout() {
        localStorage.removeItem('access')
        localStorage.removeItem('ttl')
        localStorage.removeItem('user')
        localStorage.removeItem('ttlDate')
        window.location.href = '/login'
      },
    },
    watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          document.title = to.meta.title || 'Агент';
        }
      },
    }
  }
</script>
<style scoped></style>